import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import AlbumFolderUploadSuccess from './AlbumFolderUploadSuccess';
import withModal from '../../../../../../../components/global/modal/withModal';

export const ALBUM_FOLDER_UPLOAD_SUCCESS_MODAL =
  'modal/ALBUM_FOLDER_UPLOAD_SUCCESS';

const propTypes = {
  actionProps: PropTypes.shape({
    albumFolder: PropTypes.shape({
      id: PropTypes.string,
    }),
    uploadMode: PropTypes.string,
    albumFolderPhotosTargetAlbums: PropTypes.arrayOf(
      PropTypes.shape({
        albumId: PropTypes.string.isRequired,
        photoGroupId: PropTypes.string,
        displayName: PropTypes.string,
      }),
    ),
  }),
  onRequestClose: PropTypes.func,
};

const AlbumFolderUploadSuccessModal = ({
  actionProps,
  onRequestClose,
  ...props
}) => {
  const {
    albumFolder,
    uploadMode,
    albumFolderPhotosTargetAlbums,
    includesGroupPhoto,
  } = actionProps;
  return (
    <Fragment>
      <AlbumFolderUploadSuccess
        {...props}
        albumFolder={albumFolder}
        uploadMode={uploadMode ?? albumFolder.upload_mode}
        albumFolderPhotosTargetAlbums={albumFolderPhotosTargetAlbums}
        includesGroupPhoto={includesGroupPhoto}
        onRequestClose={onRequestClose}
      />
    </Fragment>
  );
};

AlbumFolderUploadSuccessModal.propTypes = propTypes;

export default withModal(AlbumFolderUploadSuccessModal, {
  name: ALBUM_FOLDER_UPLOAD_SUCCESS_MODAL,
  size: 'md',
});
